import styled, {css} from "styled-components";

export const navBurgerBreakpoint = 1023;

// const thetransition = "all .5s cubic-bezier(1,.25,0,.75) 0s";

const StyledNavbar = styled.div`

  width: 100%;
  margin: auto;

  
  width: 80%;
  margin: auto;
 

  
@media (max-width: ${navBurgerBreakpoint}px){
  width: 80%;
  position: relative;
}
`;

export const HamburgerButton = styled.img`
  font-size: 2.1rem;
  float: right;
  z-index: 2;
  position: relative;

@media (min-width: 601px) and (max-width: ${navBurgerBreakpoint}px) {
  margin-right: calc(5vw - 27px);
}

@media (min-width: ${navBurgerBreakpoint + 1}px) {
  display: none;

}
`;
export const MobilMenu = styled.nav`
  display: flex;
  flex-direction: column;
  background-color: lightgray;
  opacity: 0.9;
  position: absolute;
  top: 2em;
  border: 0;
  right: -2em;
  width: 40%;
  padding: 1rem 2rem;
  transform: ${({ open }) => (open ? "translateX(0%);" : "translateX(200%);")};
  transition: transform 350ms ease-in;
  
  a{
    text-decoration: none;
    text-align: right;
    color: #005faa;
  }

@media(min-width: ${navBurgerBreakpoint + 1}px){
  display: none;
}
`;


export const navItemStyle = css`
  color: #005faa;
  text-decoration: none;
  padding: 0 1em 0 1em;
  position: relative;

  @media (max-width: 1110px){
    text-align: center;
    margin: auto;
    line-height: 2em;
  }

  &::after{
    content: '';
    position: absolute;
    width: 80%;
    transform: scaleX(0);
    height: 2px;
    bottom: 0.8em;
    left: 1em;
    background-color: #005faa;
    transform-origin: bottom left;
    transition: transform 0.25s ease-out;
  }

  &:hover::after{
    transform: scaleX(1);
    transform-origin: bottom left;
  }
`;

export const DesktopMenu = styled.nav`
  display: flex;
  flex-direction: row;

  margin-left: 30%;
  

  width: 70%;
  float: right;
  justify-content: end;

  
 a {
   ${navItemStyle}
  }

  > a:not(:first-child)::after{
    left: 0.5em;
  }

  .active {
    text-decoration: underline 2px #005faa;
    text-underline-offset: 0.54em;;
  }

  .active:hover::after{
    display: none;
  }

  h1 {
    font-size: clamp(1.1em, 1.7vw, 2em);
  }

  hr{
    border: 1px solid #005faa;
    margin: auto 0;
    height: 1em;
    
    @media (max-width: 1110px){
      height: 3em;
    }
   
    
  }
  @media(max-width: ${navBurgerBreakpoint}px){
    display: none;
  }
`;

export default StyledNavbar;